import MemberListPresenter from "./MemberListPresenter";

const MemberList = MemberListPresenter;

export default MemberList